module.exports = __webpack_public_path__ + "media/images/icons/flags/TW-e1c9b99626193b3b49d48a6a923a4202.svg";